import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAxiosInstance } from "../../../api";

var allowedExtensions = new RegExp(
  /[^\s]+(.*?).(jpg|jpeg|png|gif|JPG|JPEG|PNG|GIF)$/
);

const initialState = {
  openMiniBox: false,
  openAlbumUploadModal: {
    isOpen: false,
  },
  openUploadModal: {
    isOpen: false,
    mode: "",
  },
  openUploadDocumentModal: {
    isOpen: false,
    mode: "",
  },
  // openUploadModal: false,
  allUploadedImagesStatus: "idle",
  allUploadedImages: [],
  files: [],
  images: [],
  duplicateImages: [],
  invalidImages: [],
  isUploading: false,

  allUploadedDocFiles: [],
};

export const getAllImages = createAsyncThunk(
  "fileUpload/getAllImages",
  async (params, { rejectWithValue }) => {
    const api = await getAxiosInstance();
    try {
      const response = await api.get("list-uploaded-images", params);

      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const fileUploadSlice = createSlice({
  name: "fileUpload",
  initialState,
  reducers: {
    openMiniUploadBox: (state, action) => {
      state.openMiniBox = action.payload;
    },
    openDocMiniUploadBox: (state, action) => {
      state.openMiniDocBox = action.payload;
    },
    openUploadModalAction: (state, action) => {
      state.openUploadModal = {
        isOpen: action.payload.data,
        mode: action.payload.path,
      };
    },
    openUploadDocumentModalAction: (state, action) => {
      state.openUploadDocumentModal = {
        isOpen: action.payload.data,
        mode: action.payload.path,
      };
    },
    openAlbumUploadModalAction: (state, action) => {
      state.openAlbumUploadModal = {
        isOpen: action.payload,
      };
    },
    updateAllUploadedImages: (state, action) => {
      state.allUploadedImages = [
        ...state.allUploadedImages,
        {
          id: action.payload?.uploadResponse?.data?.result?.id,
          name: action.payload?.uploadResponse?.data?.result?.original_name,
          height: action.payload?.uploadResponse?.data?.result?.height,
          width: action.payload?.uploadResponse?.data?.result?.width,
        },
      ];
    },

    updateAllDocFiles: (state, action) => {
      state.allUploadedDocFiles = [
        ...state.allUploadedDocFiles,
        {
          id: action.payload?.uploadResponse?.data?.result?.id,
          name: action.payload?.uploadResponse?.data?.result?.original_name,
          height: action.payload?.uploadResponse?.data?.result?.height,
          width: action.payload?.uploadResponse?.data?.result?.width,
        },
      ];
    },

    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
  extraReducers: {
    [getAllImages.pending]: (state) => {
      state.allUploadedImagesStatus = "pending";
    },
    [getAllImages.fulfilled]: (state, action) => {
      state.allUploadedImages = action.payload.data.result;

      state.allUploadedImagesStatus = "success";
    },
    [getAllImages.rejected]: (state) => {
      state.allUploadedImagesStatus = "failed";
    },
    ["albumDetails/getAlbumItem/fulfilled"]: (state, action) => {
      const newImages = action?.payload?.data?.result?.images || [];
      if (newImages.length > 0) {
        state.allUploadedDocFiles = [...newImages];
      }
    },
  },
});

export const {
  openMiniUploadBox,
  openUploadModalAction,
  openUploadDocumentModalAction,
  setImages,
  setFiles,
  addDuplicate,
  addCompletedImages,
  setDuplicatesImages,
  setInvalidImages,
  updateConfig,
  updateAllUploadedImages,
  updateAllDocFiles,
  openAlbumUploadModalAction,
  openDocMiniUploadBox,
} = fileUploadSlice.actions;

export default fileUploadSlice.reducer;
